/**
 * ActivityPanelBody — User Edit Log entries for the current workspace.
 *
 * Renamed from "Activity Log" → "User Edit Log" in Session 60. Each entry:
 * who, what, when (relative time). Newest first.
 */

import React from 'react';

interface EditEntry {
  id: string;
  who: string;
  what: string;
  whenRelative: string;
}

const MOCK_EDITS: EditEntry[] = [
  { id: 'e-1', who: 'Sarah Chen', what: 'Approved Document Mapping', whenRelative: 'Just now' },
  { id: 'e-2', who: 'Marcus Wilson', what: 'Added 3 files to Data Extraction', whenRelative: '12 min ago' },
  { id: 'e-3', who: 'Clara', what: 'Generated work paper draft', whenRelative: '23 min ago' },
  { id: 'e-4', who: 'Sarah Chen', what: 'Started Substantive Procedure', whenRelative: '1 hr ago' },
];

export const ActivityPanelBody = React.memo(function ActivityPanelBody() {
  return (
    <ul className="activity-panel__list" aria-label="User edit log">
      {MOCK_EDITS.map(entry => (
        <li key={entry.id} className="activity-panel__item">
          <div className="activity-panel__item-text">
            <strong>{entry.who}</strong> {entry.what}
          </div>
          <time className="activity-panel__item-time">{entry.whenRelative}</time>
        </li>
      ))}
    </ul>
  );
});

export default ActivityPanelBody;
